import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";

interface IChimneyType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function ChimneyType(props: IChimneyType) {
    const { value, onChange, loading } = { ...props };
    const [chimneyType, setChimneyType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setChimneyType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setChimneyType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Chimney Type
            </Typography>

            <Select
                placeholder="Select chimney type"
                value={chimneyType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Building2 size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="N/A">N/A</Option>
                <Option value="Brick">Brick</Option>
                <Option value="Siding">Siding</Option>
            </Select>
        </Box>
    );
}
